import { PanelResizeHandle } from "react-resizable-panels";
import icon from './assets/images/resize.png'
import styles from "./css/resizable.css";

const ResizeHandler = ({ className = "" }) => {
    return (
        <PanelResizeHandle
          className={[styles.ResizeHandleOuter, className].join(" ")}
        >
          <div className={`resize-wrapper`}>
            <img src={icon} />
          </div>
        </PanelResizeHandle>
      );
}

export default ResizeHandler

